
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { painelSelectTriggerClass } from '@/components/painel/cms/painel-form';
import { painelSelectContentClass } from '@/components/painel/painel-styles';
import { HELP_CENTER_ROLE_LABEL } from '@/lib/article-author';
import {
  HELP_CENTER_STAFF_ROLE_ORDER,
  helpCenterRoleLabel,
} from '@/lib/painel-user-help-center-role';
import type { SiteStaffRole } from '@/lib/cms-types';
import { cn } from '@/lib/utils';

type PainelHelpCenterRoleFieldProps = {
  value: SiteStaffRole | 'none';
  onChange: (value: SiteStaffRole | 'none') => void;
  label?: string;
  hint?: string;
  previewHint?: string;
  className?: string;
  selectContentClassName?: string;
};

export function PainelHelpCenterRoleField({
  value,
  onChange,
  label = 'Cargo no xat Ajuda',
  hint = 'Opcional — Main Owner, Owner, Moderador ou Membro. Aparece abaixo do nome nos artigos.',
  previewHint = 'Prévia do cargo nos artigos publicados',
  className,
  selectContentClassName = painelSelectContentClass,
}: PainelHelpCenterRoleFieldProps) {
  const previewLabel = value !== 'none' ? helpCenterRoleLabel(value) : null;

  return (
    <div className={cn('grid gap-2', className)}>
      <Label className="font-inter text-xs font-medium text-blue-100/90">{label}</Label>
      <Select value={value} onValueChange={(v) => onChange(v as SiteStaffRole | 'none')}>
        <SelectTrigger className={painelSelectTriggerClass}>
          <SelectValue placeholder="Nenhum" />
        </SelectTrigger>
        <SelectContent position="popper" className={selectContentClassName}>
          <SelectItem value="none" className="focus:bg-white/10 focus:text-white">
            Nenhum
          </SelectItem>
          {HELP_CENTER_STAFF_ROLE_ORDER.map((roleId) => (
            <SelectItem
              key={roleId}
              value={roleId}
              className="focus:bg-white/10 focus:text-white"
            >
              {HELP_CENTER_ROLE_LABEL[roleId]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {previewLabel ? (
        <div className="flex flex-wrap items-center gap-2 pt-0.5">
          <span className="inline-flex rounded-full border border-sky-400/25 bg-blue-950/50 px-2.5 py-1 font-inter text-[11px] font-semibold text-blue-50">
            {previewLabel}
          </span>
          <span className="font-inter text-xs text-slate-500">{previewHint}</span>
        </div>
      ) : (
        <p className="font-inter text-xs text-slate-500">{hint}</p>
      )}
    </div>
  );
}
